import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/build/repo/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/PWAInstallPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/PWARegister.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/opt/build/repo/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/opt/build/repo/src/contexts/NotificationContext.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/styles/tailwind.css");
